<template>
  <div class="ren-decoration-cp ren-decoration-cp-action-card">
    <div>
      <strong>{{ title }}</strong>
      <span>{{ summary }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const title = computed(() => stringValue(props.component.props?.title, '我的'))
const summary = computed(() => {
  const parts: string[] = []
  if (booleanValue(props.component.props?.showLoginEntry, true)) parts.push('登录')
  if (booleanValue(props.component.props?.showServiceEntries, true)) parts.push('服务')
  if (booleanValue(props.component.props?.showSettings, true)) parts.push('设置')
  return parts.join(' · ')
})
</script>
